// src/apps/secret/composables/useAttachmentFragmentStore.ts
//
// Carries the attachment link-fragment (`att=id:key,...`) from the composer to
// the receipt page after creation. The fragment holds the E2EE keys, so it must
// NEVER reach the server: we stash it in sessionStorage (this tab only) keyed by
// receipt id, and the receipt page appends it to the share link locally.

const PREFIX = 'seuid:att:';

/** Persist the fragment for a receipt (no-op for an empty fragment). */
export function storeAttachmentFragment(receiptId: string, fragment: string): void {
  if (!receiptId || !fragment) return;
  try {
    sessionStorage.setItem(PREFIX + receiptId, fragment);
  } catch {
    /* sessionStorage unavailable (private mode / SSR) — link just lacks files */
  }
}

/** Read the fragment for a receipt WITHOUT removing it (idempotent display). */
export function peekAttachmentFragment(receiptId: string): string {
  if (!receiptId) return '';
  try {
    return sessionStorage.getItem(PREFIX + receiptId) ?? '';
  } catch {
    return '';
  }
}

/** Read + clear the fragment for a receipt (one consumer). */
export function takeAttachmentFragment(receiptId: string): string {
  const val = peekAttachmentFragment(receiptId);
  try {
    sessionStorage.removeItem(PREFIX + receiptId);
  } catch {
    /* ignore */
  }
  return val;
}
